import { render } from "./MailingBlockColumns.vue?vue&type=template&id=74707b96"
import script from "./MailingBlockColumns.vue?vue&type=script&lang=js"
export * from "./MailingBlockColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__